import { isEqual } from 'lodash';

export const areArraysEqual = <T>(array1: T[], array2: T[]): boolean => {
  if (array1.length !== array2.length) return false;

  const matched = Array(array2.length).fill(false);

  return array1.every((item) => {
    const index = array2.findIndex((array2Element, idx) => !matched[idx] && isEqual(item, array2Element));
    if (index === -1) return false;

    matched[index] = true;
    return true;
  });
};
